import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
    input,
    signal,
    inject,
} from '@angular/core';
import { copyMessageFn } from '@bazis/utils';
import { TooltipModule } from '@bazis/shared/components/web/tooltip/tooltip.module';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { CommonModule } from '@angular/common';
import { LocalNumberPipe } from '@bazis/shared/pipes/local-number.pipe';
import { TranslocoModule } from '@jsverse/transloco';
import { ColorDirective } from '@bazis/shared/directives/color.directive';
import { BazisConfigurationService } from '@bazis/configuration.service';

@Component({
    selector: 'bazis-coordinates',
    templateUrl: './coordinates.component.html',
    imports: [
        TooltipModule,
        IconModule,
        CommonModule,
        LocalNumberPipe,
        TranslocoModule,
        ColorDirective,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoordinatesComponent implements OnDestroy, OnInit {
    public configurationService = inject(BazisConfigurationService);

    readonly point = input<{
        type: 'Point';
        coordinates: [number, number]; // [lng, lat]
    }>();

    readonly icons = this.configurationService.controlIcons;

    readonly canCopy = input<boolean>(true);

    readonly tooltipKey = signal('tooltip.copyCoordinate');

    tooltipParams: any = null;

    timeout;

    ngOnInit(): void {}

    ngOnDestroy(): void {}

    copy(e) {
        if (!this.canCopy()) return;
        // широта, долгота
        copyMessageFn(`${this.point().coordinates[1]}, ${this.point().coordinates[0]}`);

        this.tooltipKey.set('tooltip.copied');
        e.preventDefault();
        e.stopImmediatePropagation();

        setTimeout(() => {
            this.tooltipKey.set('tooltip.copyCoordinate');
        }, 5000);
    }
}
